import $ from 'jquery';
window.$ = window.jQuery = $;

export function slickInit(){
    jQuery(document).ready(function ( $ ){
        $('.slider__box').slick({
            'arrows': true,
            'dots': false,
            //'autoplay': true,
            'autoplaySpeed': 1500,
            'slidesToShow': 3,
            'responsive': [
                {
                    'breakpoint': 993,
                    'settings': {
                        'slidesToShow': 2
                    }
                },
                {
                    'breakpoint': 769,
                    'settings': {
                        'slidesToShow': 1
                    }
                },
                {
                    'breakpoint': 577,
                    'settings': {
                        'slidesToShow': 1,
                        'arrows': false
                    }
                },
            ]
        });
        $('.gallery__box').slick({
            'arrows': false,
            'dots': true,
            //'autoplay': true,
            'autoplaySpeed': 1500
        });
    });
}